import { render } from "./SearchBar.component.vue?vue&type=template&id=3f1c87ee"
import script from "./SearchBar.component.vue?vue&type=script&lang=js"
export * from "./SearchBar.component.vue?vue&type=script&lang=js"

import "./SearchBar.component.vue?vue&type=style&index=0&id=3f1c87ee&lang=scss"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/homePage/SearchBar.component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f1c87ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f1c87ee', __exports__)) {
    console.log('reload')
    api.reload('3f1c87ee', __exports__)
  }
  
  module.hot.accept("./SearchBar.component.vue?vue&type=template&id=3f1c87ee", () => {
    console.log('re-render')
    api.rerender('3f1c87ee', render)
  })

}


export default __exports__